import { Injectable, Injector } from '@angular/core';



import { $frontendTypes } from './Utilities.frontend.types'

@Injectable({ providedIn: 'root' })
export class Utilities_FrontendFlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public Utilities: Utilities_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
